import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'
import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
   .highcharts-credits{display: none !important;},
   .highcharts-xaxis-labels text:first-of-type,
  .highcharts-xaxis-labels text:last-of-type {
    opacity: 1;
  }

`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Name = styled('div')`
  align-items: center;
  color: ${props => props.theme.palette.brand.black1};
  display: inline-flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  font-weight: normal;
  line-height: 19px;
  margin: 0;
`

export const Percentage = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
`
export const Datum = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  margin: 0;
  text-align: center;
`

export const Detail = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
  margin: 0;
  text-align: center;
`

export const Circle = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.black1};
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  margin: 0 0 0 6px;
`

export const ExclamationIcon = styled('div')`
  height: 12px;
  padding: 1px;
  outline: none;
  width: 12px;

  &::before {
    color: ${props => props.theme.palette.brand.white};
    content: '¡';
    display: block;
    font-size: 10px;
    line-height: 9px;
    margin-left: 0;
    text-align: center;
    width: 100%;
  }
`

export const Strong = styled('strong')``

export const DatumTotal = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  margin: 0;
  text-align: center;
`

export const NameTop = styled('div')`
  align-items: flex-start;
  text-align: center;
  height: 77px;
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  font-weight: normal;
  line-height: 19px;
  margin: 0;
`
